import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
// Our Components
import { useResize } from 'Hooks/useResize';
// Services
import { Login } from 'lib/api';
// Utils and Helpers
import { APP_ROUTES } from 'routes';
// Assets
import PaystandLogo from 'assets/authentication/PSLogow.svg';
import './FormResetPassword.css';

const FormResetPassword = ({ sendEmail }) => {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');
    const { screenWidth } = useResize();

    const handleResetPassword = useCallback(async () => {
        try {
            await Login.resetPassword(email);
            setIsSubmitting(false);
            sendEmail();
        } catch (error) {
            setError(error?.response?.data?.message);
            setIsSubmitting(false);
        }
    }, [email, sendEmail]);
    useEffect(() => {
        if (isSubmitting) {
            handleResetPassword();
        }
    }, [handleResetPassword, isSubmitting]);

    return (
        <Box id="form-reset-password-section">
            <Box>
                <Box display="flex" justifyContent="center">
                    <img className="paystand-logo" src={PaystandLogo} alt="paystand-logo" />
                </Box>
                <Box className="form-reset-password-card">
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '23px'
                        }}>
                        Reset your Password
                    </Typography>
                    <Box marginTop="12px">
                        <Typography variant="subtitle1">
                            Enter the email address associated with your Virtual Card and we'll send you a link to reset your
                            password.
                        </Typography>
                    </Box>
                    <Box marginTop="32px">
                        <TextField
                            variant="outlined"
                            size="small"
                            value={email}
                            fullWidth
                            onChange={event => setEmail(event.target.value)}
                            placeholder="Email address*"
                        />
                    </Box>
                    <Box marginTop="24px" display="flex" justifyContent="center">
                        {isSubmitting ? (
                            <CircularProgress />
                        ) : (
                            <Button
                                variant="contained"
                                className="btn-rounded"
                                disabled={email.length === 0}
                                onClick={() => setIsSubmitting(true)}
                                fullWidth
                                sx={{ color: 'white !important' }}>
                                Send Email
                            </Button>
                        )}
                    </Box>
                    <Box marginTop="24px" display="flex" justifyContent="center">
                        <Typography variant="customText" onClick={() => history.push(APP_ROUTES.LOGIN)}>
                            Back to Log In
                        </Typography>
                    </Box>
                    <Box height="2em">{error && <Alert severity="error">{error}</Alert>}</Box>
                    <Box marginTop={screenWidth > 500 ? '20px' : '15px'} display="flex" justifyContent="center">
                        <Typography variant="caption">© Paystand, Inc, 2020. All Rights Reserved.</Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default FormResetPassword;
